var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VRadioGroup',{attrs:{"value":_vm.value,"label":_vm.label},on:{"change":_vm.onChange}},_vm._l((_vm.fieldOptions),function(field,index){return _c('VRadio',{key:index,attrs:{"label":field.key,"value":field.value}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }